export const testIdPrefix = 'quickStartOnboarding';
